import { Paragraph, Stack } from '@ui'
import { useEnvironment } from 'hooks/useEnvironment'

import { TownContractInfoButtons } from './TownContractInfoButtons'

type Props = {
    name: string | undefined
    motto: string | undefined
    category: string | undefined
    address: string | undefined
}

export const TownHeader = (props: Props) => {
    const { name, motto, address } = props

    const { baseChain } = useEnvironment()
    const chainId = baseChain.id

    return (
        <Stack gap="paragraph">
            <Stack
                horizontal
                gap="sm"
                alignItems="center"
                height="x3"
                overflow="hidden"
                paddingY="x3.5"
                insetY="sm"
            >
                {name && (
                    <Paragraph
                        truncate
                        fontWeight="strong"
                        size={{ desktop: 'h2', mobile: 'h1' }}
                        color="default"
                    >
                        {name}
                    </Paragraph>
                )}
                <TownContractInfoButtons address={address} chainId={chainId} />
            </Stack>
            {motto && (
                <Stack horizontal gap="sm">
                    <Paragraph color="gray2">{motto}</Paragraph>
                </Stack>
            )}
        </Stack>
    )
}
